import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

// RxJs
import { Observable } from 'rxjs';

// ENVs
import { environment as env } from 'environments/environment';



@Injectable()
export class UrlInterceptor implements HttpInterceptor {
  
  constructor() { }
  
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.params.has('baseurl') && !!req.params.get('baseurl')) {
      return next.handle(req.clone({ params: req.params.delete('baseurl') }));
    
    } else {
      if (req.url.includes('pgs-tributarydoc-front')) {
        
        return next.handle(req.clone({ url: `${ env.baseUrl2 }${ req.url }`}));
        
      } else { return next.handle(req.clone({ url: `${ env.baseUrl }${ req.url }`})); }
    }
  }
}
